<template>
    <div class="flex gap-2">
        <div class="flex items-center" v-if="state.isExporting">
            <div>Exporting...({{ state.progress }}%)</div>

            <svg
                height="40"
                width="40"
                id="progressbar"
                :style="`stroke-dashoffset: ${progressbar};`"
            >
                <circle
                    cx="20"
                    cy="20"
                    r="10"
                    stroke="#428bca"
                    stroke-width="4"
                    fill="white"
                />
            </svg>
        </div>
        <button
            class="
                bg-primary
                rounded-lg
                py-2
                px-3
                text-white text-sm
                flex
                items-center
                gap-2
            "
            v-if="!state.isExporting"
            @click="state.isOpen = true"
        >
            <ion-icon
                name="cloud-upload-outline"
                style="font-size: 16px"
            ></ion-icon>
            Export
        </button>
        <a
            href="/"
            class="
                bg-red-500
                rounded-lg
                py-2
                px-3
                text-white text-sm
                flex
                items-center
                gap-2
            "
        >
            <ion-icon name="log-in-outline" style="font-size: 16px"></ion-icon>
            Exit
        </a>
    </div>
    <MiniModalCustom
        :is-open="state.isExportInfo"
        @close="state.isExportInfo = false"
    >
        <div class="text-center">
            <div class="text-[50px]">
                <ion-icon
                    name="checkmark-outline"
                    class="text-green-500"
                ></ion-icon>
            </div>
            <div>
                The system currently exporting your video project.<br />
                We will notify you when the process is completed.
            </div>
        </div>
    </MiniModalCustom>
    <MiniModalCustom
        :is-open="state.isOpen"
        @close="tryCloseModal"
        title="Export Video"
    >
        <div>
            <form method="post" @submit.prevent="exportProject">
                <app-input
                    maxlength="120"
                    name=""
                    placeholder="Video name (max 120 chars)"
                    type="text"
                    required
                    v-model="state.title"
                ></app-input>
                <div class="flex items-center mt-4 gap-4 justify-between">
                    <app-button
                        type="button"
                        class="flex-grow-0 flex-shrink-0"
                        @click="tryCloseModal"
                    >
                        Cancel
                    </app-button>
                    <app-button
                        type="submit"
                        :disabled="state.isExporting"
                        class="flex-grow-0 flex-shrink-0 bg-primary text-white"
                    >
                        Export
                    </app-button>
                </div>
            </form>
        </div>
    </MiniModalCustom>
</template>
<script setup>
import { computed, defineProps, defineEmits, reactive, onMounted } from "vue";
import emitter from "tiny-emitter/instance";

const emit = defineEmits(["export"]);
const state = reactive({
    isOpen: false,
    title: "",
    video_group_id: null,
    isExporting: false,
    isExportInfo: false,
    progress: 0,
    videoGroups: [],
});
const props = defineProps({
    projectId: {
        type: Number,
        required: true,
    },
});

function tryCloseSaveModal() {
    if (!state.isExporting) {
        state.saveModalOpen = false;
        state.currentClip = null;
    }
}

async function exportProject() {
    try {
        state.isExporting = true;
        const resp = await axios.post(`/project/${props.projectId}/export`, {
            title: state.title,
            video_group_id: 0,
        });

        if (resp.data) {
            state.videos = resp.data;
        }
        state.isExportInfo = true;
        getExportProgress();
    } catch (e) {
    } finally {
        state.isOpen = false;
        state.title = "";
        state.video_group_id = null;
        state.isExporting = false;
    }
}

const teamIdFromUrl = new URLSearchParams(window.location.search).get("teamId");

async function getVideoGroups() {
    const teamId = teamIdFromUrl ? teamIdFromUrl : "";
    const resp = await axios.get(`/video/groups?teamId=${teamId}`);
    if (resp.data && resp.data.length > 0) {
        state.videoGroups = resp.data;
        state.video_group_id = resp.data[0].id;
    }
}

const progressbar = computed(() => {
    return 63 - (state.progress / 100) * 63;
});

emitter.on("select-project", () => {
    getExportProgress();
});

async function getExportProgress() {
    const interval = setInterval(async () => {
        try {
            const resp = await axios.get(
                `/project/${props.projectId}/export_progress`
            );
            if (resp.data) {
                state.progress = Math.round(resp.data.progress, 0);
            }
            if (state.progress >= 100) {
                state.progress = 0;
                state.isExporting = false;
                clearInterval(interval);
            } else {
                state.isExporting = true;
            }
        } catch (e) {
            clearInterval(interval);
            state.progress = 0;
            state.isExporting = false;
        }
    }, 10000);
}

function tryCloseModal() {
    state.isOpen = false;
}

onMounted(() => {
    getVideoGroups();
});
</script>

<style scoped>
#progressbar {
    transform: rotate(-90deg);
    stroke-dasharray: 63; /* (2PI * r) */
}
</style>
